import { ReactRenderer } from '@tiptap/react';
import tippy from 'tippy.js';
import UserInfo from '../../../interfaces/UserInfo';
import { searchUsersForMentions } from '../../../services/wikiServices/WikiUserService';
import { MentionSuggestionList, MentionSuggestionListRef } from './MentionSuggestionList';

const MentionSuggestionCommands = {
  items: async ({ query, editor }: { query: string; editor: any }) => {
    const authToken = editor.options.editorProps.attributes['data-auth-token'];

    if (!authToken) {
      console.warn('Auth token not available for user search.');
      return [];
    }

    if (!query) {
      return [];
    }

    try {
      const results = await searchUsersForMentions(authToken, query);
      return results || [];
    } catch (error) {
      console.error('Error searching users for mentions:', error);
      return [];
    }
  },

  render: () => {
    let component: ReactRenderer<MentionSuggestionListRef> | null;
    let popup: any;

    return {
      onStart: (props: any) => {
        component = new ReactRenderer(MentionSuggestionList, {
          props,
          editor: props.editor,
        });

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
        });
      },
      onUpdate: (props: any) => {
        component?.updateProps(props);

        popup &&
          popup[0].setProps({
            getReferenceClientRect: props.clientRect,
          });
      },
      onKeyDown: (props: any) => {
        if (props.event.key === 'Escape') {
          popup?.[0].hide();
          return true;
        }
        return component?.ref?.onKeyDown(props) || false;
      },
      onExit: () => {
        popup?.[0].destroy();
        component?.destroy();
      },
    };
  },
};

export default MentionSuggestionCommands;
